import { FC } from "react";
import { Input } from "../Input/Input";
import { i18n } from "../../translate/i18n";
import { Search } from "../../../_metronic/partials";


type tableSearchProps = {
  perView: number
  query: string
  setQuery: (value: string) => void
  //onChangeData?: (perView: number, page: number, query: string, stateSort: string) => void
  //stateSort: string
  //meta: {
  //  page: number
  //}
  setPerView: (value: number) => void
  search?: boolean
  alterDataPerSeach: (value: string) => void
}


const TableSearch: FC<tableSearchProps> = ({perView,setPerView,query,setQuery,alterDataPerSeach,search}) => {

  return (
    <>
      <div className='d-flex justify-content-between align-items-start mb-8'>
        <div className='col-3'>
          <Input
            value={perView}
            options={[
              {select: 10, value: 10},
              {select: 25, value: 25},
              {select: 50, value: 50},
              {select: 100, value: 100},
            ]}
            inputAttr={{
              type: 'select',
              name: 'select',
            }}
            change={async (value: number) => {
              setPerView(value)
            }} 
          />
        </div>
        <div className='col-3 col-md-4 col-xl-5'>
          <Input
            value={query}
            inputAttr={{
              type: 'search',
              name: 'search',
            }}
            change={setQuery}
             
            blur={async () => {
              if(search)
                alterDataPerSeach(query)
            }}
            onKeyDown={async (value) => {
              if (value === 'Enter') {
                if(search)
                  alterDataPerSeach(query)
                
              }
            }} 
            placeholder={i18n.t(`buttons.search`)}
          />
        </div>
      </div>
    </>
  )
}

export { TableSearch }